import React, { useEffect, useState } from "react";
import { Link, navigate } from "gatsby";
import MainLayout from "../components/MainLayout";
import FullApp from "../fullapp";
import { callApi } from "../actions/base";
import {
  Button,
  Container,
  Grid,
  withStyles,
  Box,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Alert, AlertTitle } from "@material-ui/lab";

const styles = theme => ({
  buttonAccount: {
    color: "white",
  },
  loginRegisterContainer: {
    marginBottom: theme.spacing(3),
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
  },
  loginContainer: {
    margin: "auto",
    paddingBottom: theme.spacing(8),
  },
  buttonLogin: {
    margin: "auto",
    background: "#1e5abb",
    color: "white",
    "&:hover": {
      background: "#3180de",
    },
  },
  boldGray: {
    color: theme.palette.grey[700],
    fontWeight: "500",
    align: "center",
  },
  center: {
    display: "flex",
  },
  divider: {
    marginLeft: theme.spacing(8),
    marginRight: theme.spacing(8),
  },
  buttonRegister: {
    margin: "auto",
    background: "#1e5abb",
    color: "white",
    "&:hover": {
      background: "#3180de",
    },
  },
  loader: {
    color: "#1e5abb",
  },
});

const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const canBeSubmitted = form =>
  regExp.test(form.email) && form.password.length >= 8;

const Login = ({ classes }) => {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [generalError, setGeneralError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    email: false,
    password: false,
  });

  const [inputErrors, setInputErrors] = useState({
    emailError: "",
    passwordError: "",
  });

  const handleOnBlur = (form, e) => {
    const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (e.target.name === "email") {
      if (!regExp.test(form.email)) {
        setInputErrors({
          ...inputErrors,
          emailError: "Nieprawidłowy format email",
        });
      } else {
        setInputErrors({
          ...inputErrors,
          emailError: "",
        });
      }
    } else if (e.target.name === "password") {
      if (form.password.length < 8) {
        setInputErrors({
          ...inputErrors,
          passwordError: "Hasło musi zawierać conajmniej 8 znaków",
        });
      } else {
        setInputErrors({
          ...inputErrors,
          passwordError: "",
        });
      }
    }
  };

  const handleInputChange = e => {
    setValidationErrors({ ...validationErrors, [e.target.name]: false });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSuccess = data => {
    localStorage.setItem("accessToken", data.access_token);
    localStorage.setItem("refreshToken", data.refresh_token);
    navigate("/dashboard");
    setLoading(false);
  };

  const onError = data => {
    if (data.errors) {
      setValidationErrors(data.errors);
    }
    if (data.error) {
      setGeneralError(data.error);
    }
    setLoading(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    callApi("/auth/login", form, onSuccess, onError);
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <FullApp>
      <MainLayout
        topBarActions={() => (
          <Link to="/login">
            <Button variant="outlined" className={classes.buttonAccount}>
              Konto
            </Button>
          </Link>
        )}
      >
        <Container className={classes.loginRegisterContainer}>
          <Grid container style={{ backgroundColor: "#F9FBFD" }}>
            <Grid container item xs={12} sm={6}>
              <Grid
                container
                item
                component="form"
                onSubmit={handleSubmit}
                xs={12}
              >
                <Grid item xs={12}>
                  <Box m={3} align="center">
                    <Typography variant="h4">Zaloguj</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box m={2}>
                    <TextField
                      required
                      autoComplete="email"
                      fullWidth
                      label="Email"
                      name="email"
                      size="small"
                      type="email"
                      variant="outlined"
                      helperText={
                        validationErrors.email || inputErrors.emailError
                      }
                      error={
                        validationErrors.email || inputErrors.emailError != ""
                      }
                      onChange={handleInputChange}
                      value={form.email}
                      onBlur={e => handleOnBlur(form, e)}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box m={2}>
                    <TextField
                      required
                      id="current-password"
                      autoComplete="current-password"
                      fullWidth
                      label="Hasło"
                      name="password"
                      size="small"
                      type={showPassword ? "text" : "password"}
                      variant="outlined"
                      helperText={
                        validationErrors.password || inputErrors.passwordError
                      }
                      error={
                        validationErrors.password ||
                        inputErrors.passwordError != ""
                      }
                      onChange={handleInputChange}
                      value={form.password}
                      onBlur={e => handleOnBlur(form, e)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword((show) => !show)}
                              onMouseDown={e => e.preventDefault()}
                            >
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  {generalError && (
                    <Box m={1}>
                      <Alert severity="error">
                        <AlertTitle>{generalError}</AlertTitle>
                        Try again!
                      </Alert>
                    </Box>
                  )}
                  <Box m={3} align="center">
                    {loading ? (
                      <div>
                        <CircularProgress className={classes.loader} />
                      </div>
                    ) : (
                      <Button
                        type="submit"
                        className={classes.buttonLogin}
                        variant="contained"
                        disabled={!canBeSubmitted(form)}
                        disableElevation
                      >
                        Zaloguj
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item xs={12} sm={6}>
              <Grid item xs={12} style={{ alignSelf: "flex-end" }}>
                <Box my={3} align="center">
                  <Typography variant="h4">Utwórz nowe konto</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} align="center">
                <Box my={3} align="center">
                  <Link to="/register">
                    <Button
                      type="submit"
                      className={classes.buttonRegister}
                      disableElevation
                      variant="contained"
                    >
                      Przejdź do rejestracji
                    </Button>
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </MainLayout>
    </FullApp>
  );
};

export default withStyles(styles)(Login);
